'use strict';

function noop () {}

module.exports = noop;



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/noop.js
// module id = 283
// module chunks = 0